import { BudgetControlItemApiModel } from '@/core/models/api/budget-control-item-api.model';
import { ProjectStructureApiModel } from '@/core/models/api/project-structure.model';

export interface BudgetControlItemState {
  items: ProjectStructureApiModel[];
  loadedProjectId: number | null;
  loading: boolean;
  error: any;
}

export const initialBudgetControlItemState: BudgetControlItemState = {
  items: [],
  loadedProjectId: null,
  loading: false,
  error: null,
};
